import React, {useEffect, useMemo, useState} from "react";
import {api} from "../utils/gashtaltAPI";
import Loader from "../components/Loader";
import ErrorPage from "../components/ErrorPage";
import Navbar from "../components/Navbar";
import {Table, TableContainer, Tbody, Td, Thead, Tr} from "@chakra-ui/react";
import {toPersianNumber} from "../utils/numberConversion";
import {useNavigate, useParams} from "react-router-dom";
import TableToolbar from "../components/TableToolbar";
import EmptyState from "../components/EmptyState";

const PAGE_TITLES = {
    Reports: "انتخاب آزمون برای مشاهده کارنامه ها",
    Invoices: "انتخاب محصول برای مشاهده پرداخت ها",
};

function Products() {
    const {Type} = useParams()
    const [products, setProducts] = useState([]);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                const response = await api.get('/api/products')
                setProducts(response.data.data);
            } catch (error) {
                setError(error)
                console.log(error)
            } finally {
                setLoading(false);
            }
        }
        fetchData();
    }, []);

    const visibleProducts = useMemo(
        () => (products ?? []).filter((product) => !(Type === 'Reports' && product.product_type !== 1)),
        [products, Type]
    );

    if (loading) return <Loader/>
    if (error) return <ErrorPage error={error}/>;
    return (
        <div className="d-flex flex-column h-100">
            <Navbar/>
            <div className="admin-page flex-fill">
                <TableToolbar title={PAGE_TITLES[Type] ?? "محصولات"} count={visibleProducts.length}/>

                <div className="admin-table-card">
                    <TableContainer>
                        <Table variant='striped' colorScheme='teal'>
                            <Thead>
                                <Tr>
                                    <Td>ردیف</Td>
                                    <Td>نام</Td>
                                    <Td>نوع محصول</Td>
                                    <Td>نمایش</Td>
                                </Tr>
                            </Thead>
                            <Tbody>
                                {visibleProducts.map((product, index) => (
                                    <Tr key={product.id}>
                                        <Td>{toPersianNumber(index + 1)}</Td>
                                        <Td>{product.name}</Td>
                                        <Td>
                                            {product.product_type == 1 && ('آزمون')}
                                            {product.product_type == 3 && ('فایل')}
                                        </Td>
                                        <Td>
                                            <button
                                                className={`btn btn-outline-green`}
                                                onClick={() => {
                                                    if (Type === "Invoices")
                                                        navigate(`/${Type}/${product.product_type}/${product.id}`)
                                                    if (Type === "Reports")
                                                        navigate(`/${Type}/${product.id}`)
                                                }}>
                                                نمایش
                                            </button>
                                        </Td>
                                    </Tr>
                                ))}
                            </Tbody>
                        </Table>
                    </TableContainer>
                    {visibleProducts.length === 0 && <EmptyState text="محصولی یافت نشد." />}
                </div>
            </div>
        </div>
    );
}

export default Products;